import {
  DESKTOP_MIN_WIDTH,
  SCREEN_ID_REFERENCE_PATH,
  SCREEN_ID_REFERENCE_PATH_MOBILE,
} from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useStore from 'hooks/useStore';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';

// {
//   "order": 1,
//   "imageUrl": {
//       "vi": "Image URL (Vn)",
//       "en": "Image URL (En)"
//   },
//   "target": "screen",
//   "destination": "screenId"
// }
const EventItem = ({ item }) => {
  const { t, locate } = useLang();
  const { state } = useStore();
  const { isMenuExpand } = state;
  const navigate = useNavigate();
  const { isDesktop } = useDetectDevice();

  let { imageUrl, target, destination } = item || {};

  const handleOnClick = () => {
    if (target === 'screen') {
      if (isDesktop) {
        navigate(SCREEN_ID_REFERENCE_PATH[destination]);
      } else {
        navigate(SCREEN_ID_REFERENCE_PATH_MOBILE[destination]);
      }
    } else {
      window.open(destination, '_blank');
    }
  };

  return (
    <EventItemStyled
      $isMenuExpand={isMenuExpand}
      $imageUrl={imageUrl?.[locate]}
      onClick={handleOnClick}
    >
      {/* <EventItemTitle>{item?.title?.[locate]}</EventItemTitle> */}
      {/* <EventItemDesc>{item?.shortDescription?.[locate]}</EventItemDesc> */}
      {/* <EventItemLink
        href={'https://google.com.vn'}
        $isMenuExpand={isMenuExpand}
      >
        {t('label_view_terms_and_conditions')}
      </EventItemLink> */}
    </EventItemStyled>
  );
};

const EventItemStyled = styled.div`
  width: 252px;
  height: 100px;
  border-radius: 10px;
  padding: 10px 80px 10px 10px;
  background-color: #f0f0f0;
  background-image: url(${(props) => props.$imageUrl});
  background-size: contain;
  opacity: ${(props) => !props.$isMenuExpand && 0};
  transition: 0.3s;
  margin-inline: auto;
  cursor: pointer;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: ${(props) => (props.$isMenuExpand ? '252px' : '0px')};
    padding: 10px 80px 10px 10px;
    margin-inline: unset;
  }
`;
const EventItemTitle = styled.p`
  ${paragraphMixin};
  font-weight: 700;
  color: #fff;
  font-size: 14px;
  line-height: 17px;
  height: 36px;
  margin-bottom: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const EventItemDesc = styled.p`
  ${paragraphMixin};
  font-weight: 500;
  color: #fff;
  font-size: 12px;
  line-height: 15px;
  height: 30px;
  margin-bottom: 10px;

  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
const EventItemLink = styled.a`
  ${paragraphMixin};
  font-weight: 500;
  text-decoration: none;
  color: var(--ds-c-yellow);
  font-size: 12px;
  line-height: 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  float: left;
  width: ${(props) => (props.$isMenuExpand ? '162px' : '0px')};
`;

export default EventItem;
